import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DocumentTemplateType } from '@dealstack/shared/lib/generated';
import { useMemo } from 'react';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface TemplateTypeCardItem {
	name: string;
	icon: PredefinedIcons;
}

export function useTemplateCardTypes(): Record<DocumentTemplateType, TemplateTypeCardItem> {
	const tMipManage = useTranslationMipManage();

	return useMemo(() => {
		return {
			[DocumentTemplateType.CUSTOM]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.custom'
				),
				icon: 'group-folder',
			},
			[DocumentTemplateType.NOTICE]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.notice'
				),
				icon: 'announcement-notification',
			},
			[DocumentTemplateType.GDPR_NOTICE]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_type.fatca_notice'
				),
				icon: 'announcement-notification',
			},
			[DocumentTemplateType.NOTICE_REQUIRING_ACKNOWLEDGMENT]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.notice_requiring_acknowledgement'
				),
				icon: 'announcement-notification',
			},
			[DocumentTemplateType.AGREEMENT]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.agreement'
				),
				icon: 'law-order-legal',
			},
			[DocumentTemplateType.AGREEMENT_ADVANCED_SIGNATURE]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.agreement_advanced_signature'
				),
				icon: 'law-order-legal',
			},
			[DocumentTemplateType.SCHEDULE]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.schedule'
				),
				icon: 'clock-time-watch',
			},
			[DocumentTemplateType.FORM]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.form'
				),
				icon: 'document-v3-rounded',
			},
			[DocumentTemplateType.FORM_S431]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.form_s431'
				),
				icon: 'document-v3-rounded',
			},
			[DocumentTemplateType.PRE_FILLABLE_FORM]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.pre_fillable_form'
				),
				icon: 'document-v3-rounded',
			},
			[DocumentTemplateType.UK_DEED]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.uk_deed'
				),
				icon: 'certificate-awarded',
			},
			[DocumentTemplateType.POWER_OF_ATTORNEY]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.power_of_attorney'
				),
				icon: 'verified-person-checked',
			},
			[DocumentTemplateType.SIDE_LETTER]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.side_letter'
				),
				icon: 'signed',
			},
			[DocumentTemplateType.ANNUAL_REPORT]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.annual_report'
				),
				icon: 'calendar-v3',
			},
			[DocumentTemplateType.VALUATION]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.valuation'
				),
				icon: 'money-v3',
			},
			[DocumentTemplateType.RESOLUTION]: {
				name: tMipManage(
					'investors.simple_document_workflow.template_section.template_types.resolution'
				),
				icon: 'plant-grown',
			},
		};
	}, [tMipManage]);
}
